<template>
  <div
    class="card card-alert mb-2"
    :style="{
      'border-left': '0.4rem solid ' + getColor(color),
      'background-color': getBgColor(bgColor),
      'cursor': 'pointer'
    }"
    @click="filterTheTableByAlert" >
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex flex-column w-89 alert-details">
          <div class="card-title card-title-sm text-uppercase text-white text-bold">
            {{ title }}
          </div>
          <div class="card-text mt-1 me-2 text-lighter">
            {{ body }}
          </div>
        </div>
        <div class="w-11">
          <icon-warning v-if="showIcon" class="mx-2" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import styles from "./AlertScore.vue?vue&type=style&index=0&lang=scss&module=1";
import IconWarning from "@/shared/Controls/Icons/IconWarning.vue";


export default {
  name: "AlertScore",
  components: {
    IconWarning,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    body: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "sleep",
    },
    bgColor: {
      type: String,
      default: "alert",
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    filterApplied: {
      type: Boolean,
      default: false,
    },
    filterKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      filterActive: this.filterApplied,
      alertKey: this.title+'-'+this.color,
    }
  },
  methods: {
    getBgColor(bgColor) {
      if(this.alertKey == this.filterKey) {
        return '#4A5C60';
      }
      let code = bgColor.toLowerCase();

      if (code == "alert") {
        return styles.alert;
      } else return styles.info;
    },
    getColor(color) {
      return styles[color] ? styles[color] : styles["alert"];
    },
    filterTheTableByAlert() {
      this.filterActive = !this.filterActive;
      if(this.filterActive) {
        this.$parent.filterTheTableByAlert(this.title, this.alertKey);
      } else {
        this.$parent.filterTheTableByAlert('','');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
:export {
  sleep: $color-sleep;
  recovery: $color-recovery;
  strain: $color-strain;
  general: $color-general;
  // bg colors
  alert: $g-gray-soft;
  info: $g-gray-mute;
}
.arrow-icon {
  height: 1.2rem !important;
  text-align: center;
  margin-top:0.5rem !important;
  cursor: pointer;
}
.alert-details {
  min-width: 75% !important;
}
</style>
